/**
 * Get the image URL for a child photo.
 * In development mode, uses the sample profile image or local images if photoId is a path.
 * In production, uses Google Drive thumbnail URLs.
 */
export const getChildImageUrl = (photoId: string, size: 'w250' | 'w500' = 'w500'): string => {
  // If photoId is a local path (starts with /), return it as-is
  if (photoId && photoId.startsWith('/')) {
    return photoId;
  }
  
  if (import.meta.env.DEV || photoId === 'sample' || !photoId) {
    return '/sample_profile_image.jpg';
  }
  return `https://drive.google.com/thumbnail?id=${photoId}&sz=${size}`;
};

/**
 * Get the image URL for observation photos.
 * In development mode, returns the photoUrl as-is (from stub data).
 * In production, uses the provided photoUrl.
 */
export const getObservationImageUrl = (photoUrl: string): string => {
  if (!photoUrl) {
    return '/sample_profile_image.jpg';
  }
  return photoUrl;
};

